import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const MaximizeIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="MaximizeIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/expander/maximize">
            <path
                d="M21 9V3H15M21 3L14 10M3 15V21H9M3 21L10 14"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
